import { useEffect, useState } from 'react';

import ModalWrap from '../modal-wrap';

const fieldLabelClass = 'mb-1.5 block text-sm font-medium text-gray-700';
const fieldClass =
  'w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm text-gray-900 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-red-500';

export type LinkModalValue = {
  url: string;
  text: string;
  tooltip: string;
  openInNewTab: boolean;
};

type LinkModalProps = {
  isOpen: boolean;
  initialValue: LinkModalValue;
  onClose: () => void;
  onSubmit: (value: LinkModalValue) => void;
};

export const LinkModal = ({ isOpen, initialValue, onClose, onSubmit }: LinkModalProps) => {
  const [value, setValue] = useState<LinkModalValue>(initialValue);

  useEffect(() => {
    if (isOpen) setValue(initialValue);
  }, [isOpen, initialValue]);

  const handleSubmit = () => {
    if (!value.url.trim()) return;
    onSubmit(value);
  };

  return (
    <ModalWrap isShow={isOpen}>
      <div className="flex w-full max-w-[440px] flex-col gap-5 rounded-2xl bg-white p-6 shadow-shadowPopup">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-800">Добавить ссылку</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="Закрыть"
            className="flex h-7 w-7 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            ✕
          </button>
        </div>

        <div className="flex flex-col gap-4">
          <div>
            <label className={fieldLabelClass}>URL</label>
            <input
              autoFocus
              type="text"
              placeholder="https://"
              className={fieldClass}
              value={value.url}
              onChange={(e) => setValue((v) => ({ ...v, url: e.target.value }))}
            />
          </div>

          <div>
            <label className={fieldLabelClass}>Текст ссылки</label>
            <input
              type="text"
              placeholder="Отображаемый текст"
              className={fieldClass}
              value={value.text}
              onChange={(e) => setValue((v) => ({ ...v, text: e.target.value }))}
            />
          </div>

          <div>
            <label className={fieldLabelClass}>Подсказка</label>
            <input
              type="text"
              placeholder="Текст всплывающей подсказки"
              className={fieldClass}
              value={value.tooltip}
              onChange={(e) => setValue((v) => ({ ...v, tooltip: e.target.value }))}
            />
          </div>

          <label className="flex cursor-pointer items-center gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={value.openInNewTab}
              onChange={(e) => setValue((v) => ({ ...v, openInNewTab: e.target.checked }))}
              className="h-4 w-4 rounded border-gray-300 accent-red-600"
            />
            Открывать ссылку в новом окне
          </label>
        </div>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={onClose}
            className="w-full rounded-lg border border-gray-300 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Отмена
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={!value.url.trim()}
            className="w-full rounded-lg bg-red-600 py-2.5 text-sm font-medium text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Добавить
          </button>
        </div>
      </div>
    </ModalWrap>
  );
};
